export default __webpack_public_path__ + "static/media/IMG_6315.06181f4d.JPG";